import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatOptionModule } from '@angular/material/core';
import { ListModule } from 'src/@fury/shared/list/list.module';
import { NgxMaskModule } from 'ngx-mask';
import {MatDialogModule} from '@angular/material/dialog';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTabsModule} from '@angular/material/tabs';
import { MatNativeDateModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';

import { LeadManagementRoutingModule } from './lead-management-routing.module';
import { LeadManagementComponent } from './lead-management.component';
import { LeadListComponent } from './lead-list/lead-list.component';
import { LeadDetailsComponent } from './lead-details/lead-details.component';
import { CreateNoteModalComponent } from './create-note-modal/create-note-modal.component';
import { UpdateNoteModalComponent } from './update-note-modal/update-note-modal.component';
import { FuryCardModule } from 'src/@fury/shared/card/card.module';
import { MergeLeadModalComponent } from './merge-lead-modal/merge-lead-modal.component';
import { OutgoingLeadListComponent } from './outgoing-lead-list/outgoing-lead-list.component';
import { HomeSecurityLeadListComponent } from './home-security-lead-list/home-security-lead-list.component';
import { CallrailLeadListComponent } from './callrail-lead-list/callrail-lead-list.component';
import { CallrailLeadDetailsComponent } from './callrail-lead-details/callrail-lead-details.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';

@NgModule({
  declarations: [
    LeadManagementComponent,
    LeadListComponent,
    LeadDetailsComponent,
    CreateNoteModalComponent,
    UpdateNoteModalComponent,
    MergeLeadModalComponent,
    OutgoingLeadListComponent,
    HomeSecurityLeadListComponent,
    CallrailLeadListComponent,
    CallrailLeadDetailsComponent
  ],
  imports: [
    CommonModule,
    LeadManagementRoutingModule,
    FurySharedModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    MatSelectModule,
    MatChipsModule,
    MatPaginatorModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    FlexLayoutModule,
    MatSlideToggleModule,
    NgxPaginationModule,
    MatCheckboxModule,
    MatIconModule,
    MatOptionModule,
    ListModule,
    NgxMaskModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    FuryCardModule,
    MatTabsModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatAutocompleteModule
  ]
})
export class LeadManagementModule { }
